/**
 * @param {type} 宝丽丝路由
 * @return:
 */
import colorFormTrimStore from "@/views/main/colorTrim/form.js";
import blendcolorFormTrimStore from "@/views/main/blendColorTrim/form.js";
export default [
  // 打样工作台
  // 下发
  {
    path: "/issueTableBls",
    meta: { alias: "/blsOrder-proofingSystemsBls" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/index.vue"
      ),
    children: [
      // 小样下发
      {
        path: "",
        meta: {
          alias: "/blsOrder-issueTableBls",
          parentRouter: "/issueTableBls",
        },
        component: () =>
          import(
            /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/issueTable/index.vue"
          ),
      },
      // 复样下发
      {
        path: "duplicateTableBls",
        meta: {
          alias: "/blsOrder-duplicateTableBls",
          parentRouter: "/issueTableBls",
        },
        component: () =>
          import(
            /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/duplicateTable/index.vue"
          ),
      },
    ],
  },
  // 打样工作台 -- 配色
  {
    path: "/dColorMatchBls",
    meta: { alias: "/blsOrder-dColorMatchBls", parentRouter: "/issueTableBls" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/colorMatch/index.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        !["/dColorMatchResBls", "/"].includes(from.path) ||
        to.path != "/dColorMatchBls"
      ) {
        localStorage.removeItem("proofingSystems");
      }
    },
  },
  // 打样工作台 -- 配色结果
  {
    path: "/dColorMatchResBls",
    meta: {
      alias: "/blsOrder-dColorMatchResBls",
      parentRouter: "/issueTableBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/colorMatch/tableRes.vue"
      ),
  },
  // 打样工作台 -- 复样配色
  {
    path: "/dBlendColorMatchBls",
    meta: {
      alias: "/blsOrder-dBlendColorMatchBls",
      parentRouter: "/issueTableBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/BlendColorMatch/index.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        !["/dBlendColorMatchResBls", "/"].includes(from.path) ||
        to.path != "/dBlendColorMatchBls"
      ) {
        sessionStorage.removeItem("BlendProofingSystems");
      }
    },
  },
  // 打样工作台 -- 复样配色结果
  {
    path: "/dBlendColorMatchResBls",
    meta: {
      alias: "/blsOrder-dBlendColorMatchResBls",
      parentRouter: "/issueTableBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/BlendColorMatch/tableRes.vue"
      ),
  },
  // 打样工作台 -- 记录
  {
    path: "/dRecordBls",
    meta: { alias: "/blsOrder-dRecordBls", parentRouter: "/issueTableBls" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/record/index.vue"
      ),
  },
  // 打样工作台 员工操作
  {
    path: "/workbenchBls",
    meta: { alias: "/blsOrder-workbenchBls" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/workbench/index.vue"
      ),
    children: [
      // 小样下发
      {
        path: "",
        meta: { alias: "/blsOrder-WissueTableBls" },
        component: () =>
          import(
            /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/workbench/mainPage.vue"
          ),
      },
      // 复样下发
      {
        path: "WduplicateTableBls",
        meta: {
          alias: "/blsOrder-WduplicateTableBls",
          parentRouter: "/workbenchBls",
        },
        component: () =>
          import(
            /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/workbench/BmainPage.vue"
          ),
      },
    ],
  },
  // 打样工作台 员工操作 -- 配色
  {
    path: "/workbenchMatchBls",
    meta: {
      alias: "/blsOrder-workbenchMatchBls",
      parentRouter: "/workbenchBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/workbench/colorMatch.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        !["/wColorMatchResBls", "/"].includes(from.path) ||
        to.path != "/workbenchMatchBls"
      ) {
        localStorage.removeItem("workbenchColor");
      }
    },
  },
  // 打样工作台 员工操作 -- 配色结果
  {
    path: "/wColorMatchResBls",
    meta: {
      alias: "/blsOrder-wColorMatchResBls",
      parentRouter: "/workbenchBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/workbench/tableRes.vue"
      ),
  },
  // 打样工作台 员工操作 -- 混纺配色
  {
    path: "/workbenchBlendMatchBls",
    meta: {
      alias: "/blsOrder-workbenchBlendMatchBls",
      parentRouter: "/workbenchBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/workbench/BlendColorMatch.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        !["/wBlendColorMatchResBls", "/"].includes(from.path) ||
        to.path != "/workbenchBlendMatchBls"
      ) {
        sessionStorage.removeItem("workbenchBlendColor");
      }
    },
  },
  // 打样工作台 员工操作 -- 混纺配色结果
  {
    path: "/wBlendColorMatchResBls",
    meta: {
      alias: "/blsOrder-wBlendColorMatchResBls",
      parentRouter: "/workbenchBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/workbench/BlendTableRes.vue"
      ),
  },
  // 打样工作台 员工操作 修色
  {
    path: "/workbenchTrimFormBls",
    meta: {
      alias: "/blsOrder-workbenchTrimFormBls",
      parentRouter: "/workbenchBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/colorTrim/form.vue"),
    beforeEnter: (to, from) => {
      if (
        ![
          "/workbenchTrimFormResultBls",
          "/",
          "/workbenchTrimFormadjustmentBls",
        ].includes(from.path) ||
        to.path != "/workbenchTrimFormBls"
      ) {
        sessionStorage.removeItem("_params");
        sessionStorage.removeItem("resultList");
        colorFormTrimStore.init();
      }
    },
  },
  // 打样工作台 员工操作 修色结果
  {
    path: "/workbenchTrimFormResultBls",
    meta: {
      parentRouter: "/workbenchBls",
      alias: "/blsOrder-workbenchTrimFormResultBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/colorTrim/formResult.vue"),
  },
  // 打样工作台 员工操作 微调结果
  {
    path: "/workbenchTrimFormadjustmentBls",
    meta: {
      parentRouter: "/workbenchBls",
      alias: "/blsOrder-workbenchTrimFormadjustmentBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/colorTrim/adjustment.vue"),
  },

  // 打样工作台 员工操作 混纺修色
  {
    path: "workBlend-color-trim-formBls",
    meta: {
      parentRouter: "/workbenchBls",
      alias: "/blsOrder-workBlend-color-trim-formBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/blendColorTrim/indenTform.vue"),
    beforeEnter: (to, from) => {
      if (
        ![
          "/workBlend-color-trim-form-resultBls",
          "/",
          "/workBlend-color-trim-form-adjustment-resultBls",
        ].includes(from.path)
      ) {
        blendcolorFormTrimStore.init();
        sessionStorage.removeItem("colorTableListTrim");
      }
    },
  },
  // 打样工作台 员工操作 混纺修色结果
  {
    path: "/workBlend-color-trim-form-resultBls",
    meta: {
      parentRouter: "/workbenchBls",
      alias: "/blsOrder-workBlend-color-trim-form-resultBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/blendColorTrim/formResult.vue"),
  },
  // 打样工作台 员工操作 混纺修色微调结果
  {
    path: "/workBlend-color-trim-form-adjustment-resultBls",
    meta: {
      parentRouter: "/workbenchBls",
      alias: "/blsOrder-workBlend-color-trim-form-adjustment-resultBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/blendColorTrim/adjustment.vue"),
  },
  // 打样工作台 员工操作 混纺一浴修色
  {
    path: "/workBlend-color-oneBathProcessBls",
    meta: {
      parentRouter: "/workbenchBls",
      alias: "/blsOrder-workBlend-color-oneBathProcessBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/blendColorTrim/oneBathProcess/indenTform.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        ![
          "/workBlend-color-oneBathProcess-resultBls",
          "/",
          "/workBlend-oneBathProcess-adjustment-resultBls",
        ].includes(from.path)
      ) {
        sessionStorage.removeItem("oneBathResult");
      }
    },
  },
  // 打样工作台 员工操作 混纺一浴法结果
  {
    path: "/workBlend-color-oneBathProcess-resultBls",
    meta: {
      parentRouter: "/workbenchBls",
      alias: "/blsOrder-workBlend-color-oneBathProcess-resultBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/blendColorTrim/oneBathProcess/result.vue"
      ),
  },
  // 打样工作台 员工操作 混纺一浴法微调结果
  {
    path: "/workBlend-oneBathProcess-adjustment-resultBls",
    meta: {
      parentRouter: "/workbenchBls",
      alias: "/blsOrder-workBlend-oneBathProcess-adjustment-resultBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/blendColorTrim/adjustment.vue"),
  },

  // 打样工作台 员工操作 -- ABC页面(小样)
  // 录入ABC样
  {
    path: "/workbenchBlendABCBls",
    meta: {
      alias: "/blsOrder-workbenchBlendABCBls",
      parentRouter: "/workbenchBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/ABC/blendAbc.vue"),
  },
  // 录入ABC样 混纺
  {
    path: "/workbenchABCBls",
    meta: { alias: "/blsOrder-workbenchABCBls", parentRouter: "/workbenchBls" },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/ABC/index.vue"),
  },
  // 复样进入ABC页面
  {
    path: "/workbenchDABCBls",
    meta: {
      alias: "/blsOrder-workbenchDABCBls",
      parentRouter: "/workbenchBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/ABC/dIndex.vue"),
  },
  // 混纺复样进入ABC页面
  {
    path: "/workbenchBlendDABCBls",
    meta: {
      alias: "/blsOrder-workbenchBlendDABCBls",
      parentRouter: "/workbenchBls",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/ABC/dBlendAbc.vue"),
  },
  // 订单 --- 数据看板工作台(机械臂)
  //   {
  //     path: "/boardBls",
  //     meta: { alias: "/blsOrder-board" },
  //     component: () =>
  //       import(/* @vite-ignore */ "../views/main/indent/board/index.vue"),
  //   },
  //订单 ---  滴液机列表 dripMachineList
  {
    path: "/dripMachineListBls",
    meta: {
      alias: "/blsOrder-dripMachineListBls",
      parentRouter: "/workbenchBls",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystemsBLS/workbench/dripMachineList.vue"
      ),
  },
  // 打样员管理
  {
    path: "/proofingPressBls",
    meta: { alias: "/blsOrder-proofingPressBls" },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/proofingPress/index.vue"),
  },
  // 生产工艺
  {
    path: "/blsCraft",
    meta: { alias: "/blsProduction-blsCraft" },
    component: () =>
      import(/* @vite-ignore */ "../views/main/BLSProduction/craft/index.vue"),
  },
  // 生产工艺新增编辑
  {
    path: "/blsAddCraft",
    meta: {
      alias: "/blsProduction-blsAddCraft",
      parentRouter: "/blsCraft",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/BLSProduction/craft/editOrAdd.vue"
      ),
  },
  // 生产工艺详情
  {
    path: "/detailCraft",
    meta: {
      alias: "/blsProduction-detailCraft",
      parentRouter: "/blsCraft",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/BLSProduction/craft/detail.vue"),
  },
  // 生产订单
  {
    path: "/vieldOrder",
    meta: { alias: "/blsProduction-vieldOrder" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/BLSProduction/vieldOrder/index.vue"
      ),
  },
  //开卡
  {
    path: "/openCard",
    meta: { alias: "/blsProduction-vieldOrder", parentRouter: "/vieldOrder" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/BLSProduction/vieldOrder/openCard/index.vue"
      ),
  },
  //上传色样
  {
    path: "/uploadColorS",
    meta: { alias: "/blsProduction-uploadColorS", parentRouter: "/vieldOrder" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/BLSProduction/vieldOrder/uploadColorS/index.vue"
      ),
  },
  //宝丽丝 报表管理 加色加料报表
  {
    path: "/aColorMaterialReport",
    meta: { alias: "/aColorMaterialReport" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/reportManage/aColorMaterialReport/index.vue"
      ),
  },
  //宝丽丝 报表管理 染助剂用量统计
  {
    path: "/auxiliariesDosageStatistics",
    meta: { alias: "/auxiliariesDosageStatistics" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/reportManage/auxiliariesDosageStatistics/index.vue"
      ),
  },
];
